<template>
  <div id="app">
    <router-view />
    <div class="beian"><a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2022024226号-1</a></div>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
}

html,
body {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

a {
  text-decoration: none;
  color: unset;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.beian {
  position: absolute;
  bottom: 20px;
  width: 600px;
  height: 60px;
  left: 0;
  right: 0;
  margin-left: 0;
  margin-right: 0;
  margin: auto;
  border-radius: 60px;
  background-color: #7de87d;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  opacity: 0.8;
}
</style>



// WEBPACK FOOTER //
// src/App.vue